export default __webpack_public_path__ + "static/media/Mana Potion.d549a212.jpg";